/* eslint-disable max-lines */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
/**
 * PowerPortal Existing User Form Handler
 * Handles preference/COP-access updates for existing users
 */

import { isAuthorMode } from '@site/js/utils/author-mode';

import { getFrontendValidationErrors, printFormValidationErrors } from '../form/form-validation';

(function() {
  'use strict';

  const LOADER_ID = 'powerportal-loader';
  const RECAPTCHA_FIELD_NAME = 'recaptcha';
  const ARIA_INVALID_ATTR = 'aria-invalid';
  const ELEMENT_ID_SUBMIT_BUTTON = 'signup-form-existing-user-submit';
  const ELEMENT_ID_EMAIL_FIELD = 'email-container-existing-user';
  const FORM_CONTEXT_SELECTOR = 'formcontext';
  const EXISTING_REGISTRATION_SELECTOR = 'existingregistration';
  const STATUS_ALREADY_HAS_ACCESS = 'already-has-access';

  let signupToken = null;
  let isContextReady = false;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }


  function buildSelectorUrl(selector) {
    const path = window.location.pathname
      .replace(/\.html$/, '')
      .replace(/\/+$/, '');
    return `${path}.${selector}.json`;
  }

  function hasTokenInUrl() {
    return Boolean(new URLSearchParams(window.location.search).get('token'));
  }


  function isExperienceFragmentAuthorMode() {
    try {
      return Boolean(window.Granite?.author);
    } catch {
      return false;
    }
  }

  function hideLoader(formEl) {
    document.querySelectorAll(`#${LOADER_ID}`).forEach(node => node.remove());
    if (formEl) {
      formEl.removeAttribute('aria-busy');
    }
  }

  function showCaptchaRequiredError(formEl) {
    const recaptchaInput = document.getElementsByName(RECAPTCHA_FIELD_NAME)[0];
    if (recaptchaInput) {
      recaptchaInput.required = true;
      recaptchaInput.setAttribute(ARIA_INVALID_ATTR, 'true');
      recaptchaInput.setCustomValidity('Captcha required');
    }
    document.querySelector('.cmp-form-captcha')?.classList.add('is-empty');
    const validationErrors = getFrontendValidationErrors(formEl);
    if (validationErrors.size > 0) {
      printFormValidationErrors(validationErrors);
    }
    const captchaInfoBox = document.querySelector('[data-component="Infobox"]');
    if (captchaInfoBox) {
      captchaInfoBox.style.display = 'block';
    }
  }

  function init() {
    // Check if this page has the existing user form
    const submitButton = document.getElementById(ELEMENT_ID_SUBMIT_BUTTON);
    const emailFieldExistingUser = document.getElementById(ELEMENT_ID_EMAIL_FIELD);

    if (!submitButton && !emailFieldExistingUser) {
      return;
    }

    if (emailFieldExistingUser) {
      emailFieldExistingUser.disabled = true;
      emailFieldExistingUser.style.cursor = 'not-allowed';
    }

    const formElement = submitButton ? submitButton.closest('form') : null;

    const requestsCopCheckbox = document.querySelector('input.cmp-form-options__field--checkbox[name="My Application Access"]');
    const businessJustificationInput = document.getElementById('cop-access-bussiness-justification');
    const slaContractNumberInput = document.getElementById('cop-access-sla');
    const businessJustificationWrapper = businessJustificationInput?.closest('.text');
    const slaContractNumberWrapper = slaContractNumberInput?.closest('.text');
    const clearFieldError = (wrapperEl, inputEl) => {
      wrapperEl?.classList.remove('is-empty', 'is-invalid');
      wrapperEl?.querySelector('.cmp-form__error-message')?.remove();
      inputEl?.setAttribute(ARIA_INVALID_ATTR, 'false');
    };
    const requestsCopFieldNode = requestsCopCheckbox?.closest('.cmp-form-options');
    const clearRequestsCopRequired = () => {
      requestsCopFieldNode?.querySelectorAll('[required]').forEach(el => el.removeAttribute('required'));
      clearFieldError(requestsCopFieldNode, requestsCopCheckbox);
    };
    clearRequestsCopRequired();
    const updateCopAccessFieldsVisibility = () => {
      clearRequestsCopRequired();
      const showCopFields = requestsCopCheckbox?.checked || false;
      if (businessJustificationInput) {
        businessJustificationInput.disabled = !showCopFields;
        // Clear on hide so a value typed before unchecking the box is never silently included in
        // the submitted payload (and so re-checking the box always starts from a blank field).
        if (!showCopFields) {
          businessJustificationInput.value = '';
          clearFieldError(businessJustificationWrapper, businessJustificationInput);
        }
      }
      if (slaContractNumberInput) {
        slaContractNumberInput.disabled = !showCopFields;
        if (!showCopFields) {
          slaContractNumberInput.value = '';
          clearFieldError(slaContractNumberWrapper, slaContractNumberInput);
        }
      }
      if (businessJustificationWrapper) {
        businessJustificationWrapper.style.display = showCopFields ? '' : 'none';
      }
      if (slaContractNumberWrapper) {
        slaContractNumberWrapper.style.display = showCopFields ? '' : 'none';
      }
    };

    updateCopAccessFieldsVisibility();
    requestsCopCheckbox?.addEventListener('change', updateCopAccessFieldsVisibility);
    window.captchaSolved = () => new Promise(resolve => {
      document.getElementsByName(RECAPTCHA_FIELD_NAME)[0].required = false;
      document.querySelector('.cmp-form-captcha')?.classList.remove('is-empty');
      document.querySelector('#recaptcha')?.setAttribute(ARIA_INVALID_ATTR, 'false');
      resolve();
    });

    window.recaptchaExpired = () => {
      const recaptchaInput = document.getElementsByName(RECAPTCHA_FIELD_NAME)[0];
      recaptchaInput.required = true;
      recaptchaInput.setAttribute(ARIA_INVALID_ATTR, 'true');
    };

    if (submitButton) {
      submitButton.disabled = true;
    }
    resolveSignupToken(formElement, emailFieldExistingUser, submitButton);

    // Handle submit button click
    if (submitButton) {
      submitButton.addEventListener('click', function(event) {
        event.preventDefault();

        if (!isContextReady) {
          return;
        }

        if (document.getElementById(LOADER_ID)) {
          return;
        }

        const captchaToken = typeof grecaptcha !== 'undefined' ? window.grecaptcha.getResponse() : '';
        if (!captchaToken) {
          showCaptchaRequiredError(formElement);
          return;
        }

        const successPageUrl = formElement?.getAttribute('data-pp-sign-up-form-success-page-url');
        const homePageUrl = formElement?.getAttribute('data-pp-sign-up-form-home-page-url');
        const errorMessage = formElement?.getAttribute('data-pp-sign-up-form-error-message');
        const cleanErrorMessage = errorMessage ? errorMessage.replace(/<[^>]*>/g, '') : 'Something went wrong. Please try again.';

        const requestsCop = requestsCopCheckbox?.checked || false;
        const businessJustification = businessJustificationInput ? businessJustificationInput.value.trim() : '';
        const slaContractNumber = slaContractNumberInput ? slaContractNumberInput.value.trim() : '';

        if (requestsCop && !businessJustification) {
          const infoBox = document.querySelector('[data-component="Infobox"]');
          if (infoBox) {infoBox.style.display = 'block';}
          return;
        }

        // Get all checked preference checkboxes
        const preferences = Array.from(
          document.querySelectorAll('input.cmp-form-options__field--checkbox[name="My Preferences"]:checked')
        ).map(checkbox => checkbox.value);

        // Disable button to prevent multiple clicks
        submitButton.disabled = true;
        submitButton.textContent = 'Please wait...';

        // Hide any error messages before showing loader
        const errorMessages = document.querySelectorAll('.cmp-form-text__error-message, [data-component="Infobox"]');
        errorMessages.forEach(error => {
          error.style.display = 'none';
        });

        // Create and show full-page loader
        formElement.setAttribute('aria-busy', 'true');
        const loader = document.createElement('div');
        loader.id = LOADER_ID;
        loader.className = LOADER_ID;
        loader.setAttribute('role', 'status');
        loader.setAttribute('aria-live', 'polite');
        loader.innerHTML = `
          <div class="powerportal-loader__modal">
            <div class="powerportal-loader__spinner"></div>
            <p class="powerportal-loader__text">Processing your request...</p>
          </div>
        `;
        document.body.appendChild(loader);

        const requestBody = {
          token: signupToken,
          requestsCop,
          businessJustification,
          slaContractNumber,
          preferences,
          'g-recaptcha-response': captchaToken
        };

        const existingUserRequestUrl = buildSelectorUrl(EXISTING_REGISTRATION_SELECTOR);

        fetch(existingUserRequestUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestBody)
        })
        .then(async (response) => {
          const contentType = response.headers.get('content-type') || '';
          const data = contentType.includes('application/json')
            ? await response.json()
            : await response.text();

          return {
            ok: response.ok,
            status: response.status,
            data
          };
        })
        .then(({ ok, status, data }) => {
          hideLoader(formElement);

          if (!ok || status !== 200 || typeof data !== 'object') {
            throw new Error(data?.message || 'Registration submission failed');
          }

          if (data?.status === STATUS_ALREADY_HAS_ACCESS) {
            alert(data.message);

            const continueUrl = successPageUrl || homePageUrl;
            if (continueUrl && hasTokenInUrl()) {
              window.location.href = continueUrl;
            } else {
              submitButton.disabled = false;
              submitButton.textContent = 'Submit';
            }
            return;
          }

          if (successPageUrl && hasTokenInUrl()) {
            window.location.href = successPageUrl;
          } else {
            submitButton.disabled = false;
            submitButton.textContent = 'Submit';
          }
        })
        .catch(error => {
          hideLoader(formElement);

          alert(error?.name === 'Error' && error.message ? error.message : cleanErrorMessage);
          submitButton.disabled = false;
          submitButton.textContent = 'Submit';
        })
        .finally(() => {
          if (typeof grecaptcha !== 'undefined') {
            window.grecaptcha.reset();
          }
        });
      });
    } else {
      console.warn('Submit button not found');
    }
  }

  function resolveSignupToken(formElement, emailInput, submitButton) {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const homePageUrl = formElement?.getAttribute('data-pp-sign-up-form-home-page-url');
    const linkExpiredPageUrl = formElement?.getAttribute('data-pp-sign-up-form-link-expired-page-url');

    if (!token) {
      if (linkExpiredPageUrl && !isAuthorMode() && !isExperienceFragmentAuthorMode()) {
        window.location.replace(linkExpiredPageUrl);
      }
      return;
    }

    const contextUrl = `${buildSelectorUrl(FORM_CONTEXT_SELECTOR)}?token=${encodeURIComponent(token)}`;

    fetch(contextUrl)
      .then(async (response) => {
        const data = await response.json().catch(() => ({}));

        return { ok: response.ok, data };
      })
      .then(({ ok, data }) => {
        if (!ok || !data?.valid) {
          throw new Error('Invalid or expired signup session');
        }
        signupToken = token;
        isContextReady = true;
        if (emailInput && data.email) {
          emailInput.value = data.email;
        }
        if (submitButton) {
          submitButton.disabled = false;
        }
      })
      .catch((err) => {
        signupToken = null;
        isContextReady = false;
        if (linkExpiredPageUrl) {
          window.location.replace(linkExpiredPageUrl);
        }
      });
  }

})();
